// extracted by mini-css-extract-plugin
export default {"adminModal":"AdminModal_adminModal__t-B6W"};